import React, { useState, useRef, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { FaBars } from "react-icons/fa";
import html2canvas from "html2canvas";

import "../App.css";
import Network from "../components/Network";
import table from "../../src/table.png";
// Your component code here
function MetricDropdown() {
  const [selectedOption, setSelectedOption] = useState("options");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [metricDropdownOpen, setMetricDropdownOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  // const [isAutoScale, setIsAutoScale] = useState(true); // Auto-scaling state
  // const [selectedMetric, setSelectedMetric] = useState("Record Count");
  const chartContainerRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => {
      return !prev;
    });
  };
  // const handleSelect = (eventKey) => {
  //   setSelectedOption(eventKey);
  // };

  const handleFullScreen = () => {
    if (chartContainerRef.current) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        chartContainerRef.current.requestFullscreen().catch((err) => {
          console.error("Error attempting fullscreen:", err);
        });
      }
    }
  };
  const captureScreenshot = async () => {
    if (chartContainerRef.current) {
      const canvas = await html2canvas(chartContainerRef.current, {
        useCORS: true,
        scale: 2,
        fontFamily: "'Roboto Flex', serif", // Make sure the font is applied here
      });
      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = "graph.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toggleDropdown(false);
    }
  };

  useEffect(() => {
    const checkFontLoaded = () => {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          // You can now safely capture the screenshot
        });
      }
    };

    window.onload = checkFontLoaded;

    return () => {
      window.onload = null;
    };
  }, []);

  useEffect(() => {
    const onFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", onFullScreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", onFullScreenChange);
  }, []);

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: null,
      align: "center",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
    },
    xAxis: {
      categories: [
        "Inpatient (IPPS)",
        "Outpatient (OPPS)",
        "Professional (PFS)",
        "Medicare Part B Drugs (DrugB)",
      ],
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "12px",
          width: "100px",
        },
      },
    },
    yAxis: {
      title: {
        text: "% of Medicare",
        style: {
          fontSize: "14px",
          fontWeight: "light",
          fontFamily: "'Roboto Flex', serif", // Ensure this is correct
        },
      },
      plotLines: [
        {
          value: 70,
          dashStyle: "dash",
          width: 1,
          color: "#B4B4B4",
          zIndex: 5,
          label: {
            text: "threshold",
            align: "right",
            verticalAlign: "top",
            rotation: 0,
            x: 10,
            y: -5,
            style: {
              color: "#666",
              fontSize: "10px",
              fontWeight: "light",
            },
          },
        },
      ],
    },
    legend: {
      layout: "horizontal",
      fontFamily: "'Roboto Flex', serif",
      align: "center",
      verticalAlign: "bottom",
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "12px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    credits: {
      enabled: false,
    },

    plotOptions: {
      series: {
        borderRadius: 3,
        pointPadding: 0.2,
        groupPadding: 0.1,
        dataLabels: {
          enabled: true,
          // format: "{y}%",
          style: {
            fontSize: "12px",
            fontWeight: "light",
            color: "black",
          },
          inside: false,
        },
        cursor: "pointer",
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      pointFormat:
        "<div style='display:flex; flex-direction:row, align-items: center'><div style='margin-right: 0px; width:200px'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false,
      hideDelay: 0,
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        transition: "none",
        fontSize: "12px",
        padding: "8px",
        shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
        zIndex: 99999,
      },
      shadow: true,
      useHTML: true,
      outside: true,
    },
    series: [
      {
        name: "Anthem High Performance Network",
        data: [244.22, 265.96, 145.86, 133.83],
        color: "#C1E7E7",
      },
      {
        name: "Anthem Traditional Network",
        data: [238.45, 260.44, 150.38, 134.62],
        color: "#4F7A8A",
      },
      {
        name: "BC ID Blue Value POS Network",
        data: [255.04, 264.34, 145.9, 135.06],
        color: "#D1E8FF",
      },
      {
        name: "BC ID Preferred Blue Network	",
        data: [255.04, 264.34, 145.9, 135.06],
        color: "#FFD2A0",
      },
    ],
    exporting: {
      enabled: false, // Disable all exporting options
    },
  };

  const options1 = {
    chart: {
      type: "column",
    },
    title: {
      text: null,
      align: "center",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
    },
    xAxis: {
      categories: [
        "Anthem High Performance Network",
        "Anthem Traditional Network",
        "BC ID Blue Value POS Network",
        "BC ID Preferred Blue Network",
      ],
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "12px",
          width: "100px",
        },
      },
    },
    yAxis: {
      title: {
        text: "% of Medicare",
        style: {
          fontSize: "14px",
          fontWeight: "light",
          fontFamily: "'Roboto Flex', serif",
        },
      },
      plotLines: [
        {
          value: 70,
          dashStyle: "dash",
          width: 1,
          color: "#B4B4B4",
          zIndex: 5,
          label: {
            text: "threshold",
            align: "right",
            verticalAlign: "top",
            rotation: 0,
            x: 10,
            y: -5,
            style: {
              color: "#666",
              fontSize: "10px",
              fontWeight: "light",
            },
          },
        },
      ],
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderRadius: 3,
        pointPadding: 0.2,
        groupPadding: 0.1,
        dataLabels: {
          enabled: true,
          // format: "{y}%",
          style: {
            fontSize: "12px",
            fontWeight: "bold",
            color: "black",
          },
          inside: false,
        },
        cursor: "pointer",
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      pointFormat:
        "<span style='margin-right:100px; width:45px'> {series.name}</span> <span style='display: inline-block;position:absolute;padding-left:-2px;width: 50px; text-align:right;right:0'><b>{point.y}%</span></b><br/>",

      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false,
      hideDelay: 0,
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        transition: "none",
        fontSize: "12px",
        padding: "8px",
        shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
        zIndex: 99999,
      },
      shadow: true,
      useHTML: true,
      outside: true,
    },
    series: [
      {
        name: "Inpatient (IPPS)",
        data: [244.22, 238.45, 255.04, 255.04], // Data changed for testing
        color: "#C1E7E7",
      },
      {
        name: "Outpatient (OPPS)",
        data: [265.96, 260.44, 264.34, 264.34],
        color: "#4F7A8A",
      },
      {
        name: "Professional (PFS)",
        data: [145.86, 150.38, 145.9, 145.9],
        color: "#D1E8FF",
      },
      {
        name: "Medicare Part B Drugs (DrugB)",
        data: [133.83, 134.62, 135.06, 135.06],
        color: "#FFD2A0",
      },
    ],
    exporting: {
      enabled: false, // Disable all exporting options
    },
  };

  return (
    <div className="d-flex flex-column gap-3" style={{ padding: "0px 20px" }}>
      <Network />
      {/* <Dropdown onSelect={handleSelect}>
        <Dropdown.Toggle
          id="dropdown-basic"
          style={{
            backgroundColor: "white",
            color: "black",
            border: "1px solid black",
          }}
        >
          {selectedOption === "options"
            ? "Network Comparison"
            : "Categories Comparison"}
        </Dropdown.Toggle>

        <Dropdown.Menu style={{ backgroundColor: "white" }}>
          <Dropdown.Item eventKey="options" style={{ color: "black" }}>
            Network Comparison
          </Dropdown.Item>
          <Dropdown.Item eventKey="options1" style={{ color: "black" }}>
            Categories Comparison
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // gap: "30px",
          padding: "20px",
          background: "white",
        }}
      >
        <div
          className="position-relative d-flex justify-content-end "
          style={{ marginBottom: "-40px", zIndex: "999999" }}
        >
          {/* Menu button */}

          <button className="btn border p-2 " onClick={toggleDropdown}>
            <FaBars size={20} />
          </button>

          {/* Dropdown Menu */}
          {dropdownOpen && (
            <div
              className="position-absolute bg-white border rounded shadow p-2"
              style={{
                right: 0,
                top: "110%",
                minWidth: "180px",
                zIndex: 10,
              }}
            >
              <button className="dropdown-item p-2" onClick={captureScreenshot}>
                Download
              </button>
              <button className="dropdown-item p-2" onClick={handleFullScreen}>
                {isFullScreen ? "Exit Full Screen" : "View Full Screen"}
              </button>
            </div>
          )}
        </div>
        <div
          ref={chartContainerRef}
          className={`chart-container p-1 ${isFullScreen ? "fullscreen" : ""}`}
        >
          <h3 className=" w-100 d-flex justify-content-center chart-topic mb-2 pt-0">
            Network Comparison: % of Medicare
          </h3>
          <HighchartsReact
            highcharts={Highcharts}
            options={selectedOption === "options" ? options : options1}
          />
        </div>
        <img
          src={table}
          style={{
            width: "99.5%",
            margin: "0px auto",
            border: "1.5px solid #f4f5f7",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        ></img>
      </div>
    </div>
  );
}

export default MetricDropdown;
